export default "__VITE_ASSET__DtrCd2ZB__"